import { useQuery } from '@apollo/client';
import { useDealPromptPermission } from '@openx/components-deal-prompt/lib/hooks/useDealPromptPermission';
import {
  CheckIfShowMyDataDocument,
  type CheckIfShowMyDataQuery,
  type CheckIfShowMyDataQueryVariables,
} from '../../../graphql/query/audiences/CheckIfShowMyData.generated';

export const useDealPromptAudienceExternalPartnerWithData = (
  filters?: CheckIfShowMyDataQueryVariables,
  skip?: boolean
) => {
  const { isInternalUser } = useDealPromptPermission();
  const {
    data,
    loading: accountsLoading,
    error,
  } = useQuery<CheckIfShowMyDataQuery>(CheckIfShowMyDataDocument, {
    skip,
    variables: {
      ...filters,
    },
  });

  return {
    data: (data?.segment_aggregate?.aggregate?.count || 0) > 0 && !isInternalUser,
    loading: accountsLoading,
    error,
  };
};
